import React from 'react';
import { ArcStack, ArcText } from '@src/core/ui';
import { ReactComponent as RecordIcon } from './record.svg';
import { cameraPillSx } from './camera-pill-sx';

interface RecordingIndicatorProps {
  isRecording: boolean;
  onClick?: () => void;
}

const RecordingIndicator: React.FC<RecordingIndicatorProps> = ({ isRecording, onClick }) => {
  return (
    <ArcStack
      top={10}
      left={10}
      zIndex={100}
      spacing={0.5}
      direction='row'
      alignItems='center'
      position='absolute'
      onClick={onClick}
      sx={(theme) => ({
        ...cameraPillSx(theme),
        px: 1.25,
        cursor: onClick ? 'pointer' : 'default',
        '& svg': { width: 14, height: 14, display: 'block' },
      })}>
      <RecordIcon />
      <ArcText.caption sx={{ color: 'common.white', fontWeight: 500, lineHeight: 1, fontSize: 12 }}>
        Rec
      </ArcText.caption>
    </ArcStack>
  );
};

export default RecordingIndicator;
